import { ChangeDetectionStrategy, Component, InputSignal, effect, input } from '@angular/core';
import {
    countryNameById,
    regionNameById,
    settlementNameById,
} from '@shared/helpers/full-address-string';

import { AddressDetailResponse } from '@app/shared/models/chip-details.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-address-render-info',
    imports: [TranslatePipe],
    templateUrl: './address-render-info.component.html',
    styleUrl: './address-render-info.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressRenderInfoComponent {
    readonly address: InputSignal<AddressDetailResponse> = input.required();
    readonly ownerAddress: InputSignal<boolean> = input.required();
    countryName = '';
    regionName = '';
    settlementName = '';

    constructor() {
        effect(() => {
            this.countryName = countryNameById(this.address()?.countryId);
            this.regionName = regionNameById(this.address()?.regionId);
            this.settlementName = settlementNameById(this.address()?.settlementId);
        });
    }
}
